export const FIELD = {
  DECISION_ID: 'decision_id',
  ENV: 'env',
  NO_DECISION: 'no_decision',
  LEVEL_OF_PERMIT: 'level_of_permit',
  JOURNAL_NUMBER: 'journal_number',
  APPROVED_DATE: 'approved_date',
  VERIFICATION_REQ: 'vtj_verification_required',
  CONTACT_EMAILS: 'contact_person_emails',
  CLIENT_ID: 'client_id',
  JWKS_URI: 'jwks_uri',
  REDIRECT_URIS: 'redirect_uris',
  RESPONSE_TYPES: 'response_types',
  POST_LOGOUT_REDIRECT: 'post_logout_redirect_uris',
  FRONTCHANNEL_LOGOUT_URI: 'frontchannel_logout_uri',
  FRONTCHANNEL_LOGOUT: 'frontchannel_logout_session_required',
  GRANT_TYPES: 'grant_types',
  ID_TOKEN_ENC_RES_ALG: 'id_token_encrypted_response_alg',
  TOKEN_ENC_RES_ENC: 'id_token_encrypted_response_enc',
  TOKEN_SIGN_RES_ALG: 'id_token_signed_response_alg',
  TOKEN_AUTH_METHOD: 'token_endpoint_auth_method',
  SCOPE: 'scope',
  DEFAULT_ACR_VALUES: 'default_acr_values'
};

export const FIELD_VALUES = {
  ENV: {
    TESTING: 'testing',
    PRODUCTION: 'production'
  },
  TOKEN_ENC_RES_ENC: {
    A128GCM: 'A128GCM',
    A256GCM: 'A256GCM'
  },
  ID_TOKEN_ENC_RES_ALG: {
    RSA_OAEP: 'RSA-OAEP',
    RSA_OAEP_256: 'RSA-OAEP-256',
    RSA_OAEP_512: 'RSA-OAEP-512',
    ECDH_ES: 'ECDH-ES',
    ECDH_ES_A256KW: 'ECDH-ES+A256KW'
  },
  TOKEN_SIGN_RES_ALG: {
    RS256: 'RS256',
    RS512: 'RS512',
    PS256: 'PS256',
    PS512: 'PS512',
    ES256: 'ES256'
  },
  GRANT_TYPES: {
    AUTHORIZATION_CODE: 'authorization_code'
  },
  VERIFICATION_REQ: {
    TRUE: 'true',
    FALSE: 'false'
  },
  RESPONSE_TYPES: {
    CODE: 'code'
  },
  FRONTCHANNEL_LOGOUT: {
    TRUE: 'true',
    FALSE: 'false'
  },
  TOKEN_AUTH_METHOD: {
    JWT: 'private_key_jwt'
  }
};

export const LEVEL_OF_DATA_PERMIT = {
  MINIMUM: 'minimum',
  MEDIUM: 'medium',
  MAXIMUM: 'maximum',
  getValue: x =>
    ({
      1: LEVEL_OF_DATA_PERMIT.MINIMUM,
      2: LEVEL_OF_DATA_PERMIT.MEDIUM,
      3: LEVEL_OF_DATA_PERMIT.MAXIMUM
    }[x])
};

export const textFieldList = [
  'service_name_fi',
  'service_name_sv',
  'service_name_en',
  'service_name_sms',
  'service_name_smn',
  'service_name_sme',
  'service_login_page',
  'privacy_statement_url'
];
export const acrKeys = {
  test_identification: ['urn:oid:1.2.246.517.3002.110.999'],
  bundle_1: [
    'http://ftn.ficora.fi/2017/loa2',
    'http://ftn.ficora.fi/2017/loa3'
  ],
  bundle_2: ['http://ftn.ficora.fi/2017/loa3'],
  bundle_3: [
    'http://eidas.europa.eu/LoA/high',
    'http://eidas.europa.eu/LoA/substantial'
  ],
  bundle_4: ['http://eidas.europa.eu/LoA/substantial'],
  bundle_5: ['urn:oid:1.2.246.517.3002.110.7']
};

export const defaultSelectedClaims = [
  {
    labelText: 'openid',
    uniqueItemId: '1',
    disabled: true
  }
];
export const claims = [
  {
    labelText: 'names',
    uniqueItemId: '2',
    extent: 1
  },
  {
    labelText: 'domesticaddress',
    uniqueItemId: '3',
    extent: 2
  },
  {
    labelText: 'municipality',
    uniqueItemId: '4',
    extent: 2
  },
  {
    labelText: 'foreignaddress',
    uniqueItemId: '5',
    extent: 2
  },
  {
    labelText: 'protectionorder',
    uniqueItemId: '6',
    extent: 2
  },
  {
    labelText: 'mail',
    uniqueItemId: '7',
    extent: 2
  },
  {
    labelText: 'finnishcitizenship',
    uniqueItemId: '8',
    extent: 3
  },
  {
    labelText: 'eidas',
    uniqueItemId: '9',
    extent: 1
  }
];

export const initialValues = {
  acr: [],
  env: '',
  approved_date: new Date(), // NOTE: this will be overwritten if not applicable
  service_name_fi: '',
  level_of_permit: '',
  service_name_sv: '',
  service_name_en: '',
  service_name_sms: '',
  service_name_smn: '',
  service_name_sme: '',
  service_login_page: '',
  privacy_statement_url: '',
  vtj_verification_required: '',
  contact_person_emails: [''],
  client_id: '',
  default_acr_values: [],
  _default_acr_values: {},
  scope: '',
  jwks_uri: '',
  redirect_uris: [''],
  response_types: '',
  post_logout_redirect_uris: [''],
  frontchannel_logout_uri: '',
  frontchannel_logout_session_required: '',
  grant_types: '',
  id_token_encrypted_response_alg: '',
  id_token_encrypted_response_enc: '',
  id_token_signed_response_alg: '',
  token_endpoint_auth_method: ''
};
